import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import GHLForm from '../GHLForm';
import { CONSULTATION_COPY } from '../../constants/consultation';
import { useGHLFormModal } from './context';
import { usePatientPrefill } from './hooks/usePatientPrefill';
import {
  ModalContainer,
  CloseButton,
  backdropStyles,
  scrollWrapperStyles,
  SectionHeadingContainer,
} from './styles';

const GHLFormModal = () => {
  const { isOpen, formConfig, closeModal } = useGHLFormModal();
  const prefillData = usePatientPrefill();

  const handleSubmitSuccess = () => {
    setTimeout(() => {
      closeModal();
    }, 3500);
  };

  const stopPropagationHandler = (e) => {
    e.stopPropagation();
  };

  const combinedPrefillData = {
    ...prefillData,
    ...formConfig.prefillData,
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="ghl-form-modal"
      closeAfterTransition
      slotProps={{
        backdrop: {
          sx: backdropStyles,
        },
      }}
    >
      <Box sx={scrollWrapperStyles} onClick={closeModal}>
        <ModalContainer onClick={stopPropagationHandler}>
          <SectionHeadingContainer>{CONSULTATION_COPY.bookYour}</SectionHeadingContainer>
          <CloseButton onClick={closeModal}>
            <CloseIcon />
          </CloseButton>
          <GHLForm
            formURL={formConfig.formURL}
            prefillData={combinedPrefillData}
            onSubmitSuccess={handleSubmitSuccess}
          />
        </ModalContainer>
      </Box>
    </Modal>
  );
};

export default GHLFormModal;
